/* ============================================================
   widget-modal.js
   Save as: assets/widget-modal.js
   Add to theme.liquid or a layout file:
   {{ 'widget-modal.js' | asset_url | script_tag }}
   ============================================================ */

(function () {
  'use strict';

  var modal     = null;
  var backdrop  = null;
  var inner     = null;
  var closeBtn  = null;
  var spinner   = null;
  var container = null;

  // ── Init ──────────────────────────────────────────────────
  function init() {
    modal     = document.getElementById('bt-widget-modal');
    backdrop  = document.getElementById('bt-widget-backdrop');
    inner     = document.getElementById('bt-widget-inner');
    closeBtn  = document.getElementById('bt-widget-close');
    spinner   = document.getElementById('bt-widget-spinner');
    container = document.getElementById('bt-widget-container');

    if (!modal) return; // modal markup not on this page

    // Delegated click listener for all trigger buttons
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-widget-trigger]');
      if (!btn) return;
      var handle = btn.getAttribute('data-handle');
      if (handle) openWidget(handle);
    });

    // Close triggers
    closeBtn.addEventListener('click', closeModal);
    backdrop.addEventListener('click', closeModal);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeModal();
    });
  }

  // ── Open ──────────────────────────────────────────────────
  function openWidget(handle) {
    container.innerHTML = '';
    showSpinner();
    openModal();

    fetch('/products/' + handle + '?section_id=widget-renderer')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        hideSpinner();
        container.innerHTML = html;
        // Re-run any inline scripts injected by the section
        container.querySelectorAll('script').forEach(function (oldScript) {
          var newScript = document.createElement('script');
          newScript.textContent = oldScript.textContent;
          oldScript.parentNode.replaceChild(newScript, oldScript);
        });
      })
      .catch(function () {
        hideSpinner();
        container.innerHTML = '<p style="color:#c00;font-size:14px;padding:1rem 0;">Something went wrong loading this widget. Please try again.</p>';
      });
  }

  // ── Modal open/close ──────────────────────────────────────
  function openModal() {
    modal.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    trapFocusInit();
    if (closeBtn) closeBtn.focus();
  }

  function closeModal() {
    modal.classList.remove('is-open');
    document.body.style.overflow = '';
    container.innerHTML = '';
    trapFocusDestroy();
  }

  // ── Spinner ───────────────────────────────────────────────
  function showSpinner() {
    if (spinner) spinner.classList.add('is-visible');
  }

  function hideSpinner() {
    if (spinner) spinner.classList.remove('is-visible');
  }

  // ── Focus trap ────────────────────────────────────────────
  function getFocusable() {
    return Array.from(inner.querySelectorAll(
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
    ));
  }

  function trapFocus(e) {
    if (e.key !== 'Tab') return;
    var focusable = getFocusable();
    var first = focusable[0];
    var last  = focusable[focusable.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault(); last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault(); first.focus();
    }
  }

  function trapFocusInit()    { document.addEventListener('keydown', trapFocus); }
  function trapFocusDestroy() { document.removeEventListener('keydown', trapFocus); }

  // ── Boot ──────────────────────────────────────────────────
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();